<style>
.tch-info-modal .ivu-modal-wrap {
  z-index: 2000;
}
</style>
<template>
  <div>
    <Modal title="临时约课" v-model="visible" width="600" :mask-closable="false" :styles="{ right: '-300px' }" v-drag-modal>
      <Form ref="tempLessonForm" class="form"
            :model="tempLessonParam" :rules="tempLessonRule"
            :label-width="80">
        <Row>
          <Col :span="22">
            <Form-item label="学生信息">
              <label>{{ tempLessonParam.uid }} - {{ tempLessonParam.mobile }} - {{ tempLessonParam.nickname }} -
                {{ tempLessonParam.levelId }}</label>
            </Form-item>
          </Col>
          <Col :span="12">
            <Form-item label="开始Level" prop="levelId">
              <Select filterable transfer v-model.number="tempLessonParam.levelId" placeholder="请选择等级，支持搜索"
                      @on-change="changeLevel">
                <Option v-for="item in bookMaterialLevelList"
                        :value="item.id" :key="item.id">{{ item.title }}(版本{{ item.materialVersion }})
                </Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="10">
            <Form-item label="教室" prop="schoolId">
              <Select v-model.number="tempLessonParam.schoolId" transfer>
                <Option v-for="item in $constant.schoolEnums"
                        :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="22">
            <Form-item label="开始课程" prop="lessonId">
              <Select v-model.number="tempLessonParam.lessonId" transfer>
                <Option v-for="item in bookMaterialLessonsList"
                        :value="item.id" :key="item.id">{{ item.title }}
                </Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="22">
            <Form-item label="开始时间" prop="lsnBeginDayTime">
              <Row :gutter="6">
                <Col span="7">
                  <Form-item>
                    <Date-picker type="date" format="yyyy-MM-dd" placeholder="请选择日期"
                                 @on-change="lsnBeginTimeDateChange" :clearable="false"
                                 v-model="tempLessonParam.lsnBeginTimeDate"></Date-picker>
                  </Form-item>
                </Col>
                <Col span="5">
                  <Form-item>
                    <Time-picker :key="timePickerKey" @on-change="onChangeTime" :clearable="false" v-model="timeStr"
                                 format="HH:mm" :steps="[1, 30]" placeholder="时间"></Time-picker>
                  </Form-item>
                </Col>
                <Col span="4">
                  <Form-item>
                    <Select v-model.number="tempLessonParam.timeLength" transfer>
                      <Option v-for="item in timeLengthList"
                              :value="item.code" :key="item.code">{{ item.text }}
                      </Option>
                    </Select>
                  </Form-item>
                </Col>
                <Col span="5" offset="1">
                  <Button type="info" @click="searchTch" :loading="loadingSearch">搜索</Button>
                </Col>
              </Row>
            </Form-item>
            <Form-item prop="category">
              <RadioGroup v-model="tempLessonParam.makeUp">
                <Radio label="0">
                  <span>正常约课</span>
                </Radio>
                <Radio label="1">
                  <span>补课</span>
                </Radio>
              </RadioGroup>

              <RadioGroup v-model="tempLessonParam.accent">
                <Radio label="1">
                  <span>英音</span>
                </Radio>
                <Radio label="2">
                  <span>美音</span>
                </Radio>
              </RadioGroup>
              <RadioGroup v-model="tempLessonParam.sex">
                <Radio label="1">
                  <span>男</span>
                </Radio>
                <Radio label="2">
                  <span>女</span>
                </Radio>
              </RadioGroup>
              <RadioGroup v-model="tempLessonParam.channel">
                <Radio label="">
                  <span>全部</span>
                </Radio>
                <Radio label="1">
                  <span>欧美</span>
                </Radio>
                <Radio label="2">
                  <span>菲教</span>
                </Radio>
              </RadioGroup>
              <RadioGroup v-model="tempLessonParam.canBound">
                <Radio label="1">
                  <span>有绑定权限</span>
                </Radio>
                <Radio label="0">
                  <span>无绑定权限</span>
                </Radio>
              </RadioGroup>
            </Form-item>
            <Form-item label="适宜级别">
              <RadioGroup v-model="tempLessonParam.suitableLevel">
                <Radio label=""><span>全部</span></Radio>
                <Radio label="1"><span>Level1</span></Radio>
                <Radio label="5"><span>Level2</span></Radio>
                <Radio label="2"><span>Level3-Level5</span></Radio>
                <Radio label="3"><span>Level6-Level9</span></Radio>
                <Radio label="4"><span>Wonders及其他</span></Radio>
                <Radio label="6"><span>PU</span></Radio>
              </RadioGroup>
            </Form-item>
          </Col>

          <Col :span="22">
            <Form-item label="空课老师">
              <TeacherSelect :category="[1,2,3]" v-model="tId" :label="tchName"
                             @on-change="onTchChange"></TeacherSelect>
            </Form-item>
            <Form-item prop="tchId">
              <Row>
                <Radio-group v-model.number="tempLessonParam.tchId">
                  <Row>
                    <Col v-for="item in tchList" style="width: 140px;" :span="10">
                      <Radio :key="item.id" :label="item.id">{{ item.id }} - {{ item.firstName }} {{
                          item.lastName
                        }}
                      </Radio>
                      <a @click="showTchMessage(item.id)"><img
                        :src="tchAvatarSrc(item.avatar)" style="width: 120px;height: 120px"></a>
                    </Col>
                  </Row>
                </Radio-group>
              </Row>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="visible=false">取消</Button>
        <Button type="primary" size="large" :loading="loadingConfirm" @click="insertTempLesson">确定</Button>
      </div>
    </Modal>
    <tch-info-modal class="tch-info-modal" :canEdit="false" :value="showTchInfoModal" @on-close="showTchInfoModal=false"
                    :tchId="tchId" :successCallback="updateTchInfoSuccess"></tch-info-modal>
  </div>
</template>
<script>
import TchInfoModal from '../../teacher/modal/TchInfoModal'
import commonUtils from '@/tools/commonUtils.js'
import '../../../directive/drag-modal'
export default {
  name: 'UserTempLessonModal',
  components: {TchInfoModal},
  props: {
    value: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object
    },
    successCallback: {
      type: Function
    }
  },
  data () {
    let self = this
    return {
      visible: this.value,
      loadingConfirm: false,
      loadingSearch: false,
      classTypeList: [{code: 1, text: 'ClassIn'}],
      timeLengthList: [{code: 25, text: '25'}],
      bookMaterialLevelList: null,
      bookMaterialLessonsList: null,
      tchList: [],
      tchName: '',
      tId: '',
      tempLessonParam: {
        levelId: null,
        uid: null,
        category: '',
        makeUp: '',
        tchId: '',
        classType: 1,
        courseType: 1,
        lsnBeginTimeDate: null,
        lsnBeginTime: null,
        lsnBeginDayTime: null,
        timeLength: 25,
        suitableLevel: '',
        postpone: 1,
        time: null,
        sex: null,
        channel: null,
        schoolId: 0
      },
      timeStr: '',
      timePickerKey: 0,
      tempLessonRule: {
        levelId: [
          {type: 'integer', required: true, message: '请选择开始Level', trigger: 'blur'}
        ],
        lessonId: [
          {type: 'integer', required: true, message: '请选择开始课程', trigger: 'blur'}
        ],
        classType: [
          {type: 'integer', required: true, message: '请选择教室', trigger: 'change'}
        ],
        tchId: [
          {type: 'integer', required: true, message: '请搜索并选择老师', trigger: 'change'}
        ],
        lsnBeginDayTime: [
          {type: 'integer', required: true, message: '请选择日期', trigger: 'change'},
          {
            validator (rule, value, callback, source, options) {
              let errors = []
              if (self.tempLessonParam.time === '') {
                errors.push('请选择时间')
                callback(errors)
                return
              }
              let lsnBeginTime = self.getLsnBeginTime()
              let nowTime = new Date().getTime() / 1000
              if (lsnBeginTime !== '' && nowTime >= lsnBeginTime) {
                errors.push('开始时间应在当前时间之后')
                callback(errors)
                return
              }
              callback()
            }
          }
        ]
      },
      tchId: null,
      showTchInfoModal: false,
      ptype: ''
    }
  },
  methods: {
    tchAvatarSrc (avatar) {
      return commonUtils.getTotalUrl(avatar) || 'https://medias.kouyujie.cn/2018-02-09-defaultImageWechatIMG223.jpeg'
    },
    secondsFromPicker () {
      const val = this.timeStr
      if (val instanceof Date && !isNaN(val.getTime())) {
        return val.getHours() * 3600 + val.getMinutes() * 60
      }
      if (typeof val === 'string' && val.indexOf(':') !== -1) {
        return parseInt(this.$dateUtil.getSecondByHm(val), 10)
      }
      return ''
    },
    syncPickerTime () {
      const sec = this.secondsFromPicker()
      this.tempLessonParam.time = sec === '' || Number.isNaN(sec) ? '' : sec
    },
    insertTempLesson () {
      let self = this
      self.syncPickerTime()
      self.loadingConfirm = true
      self.$refs.tempLessonForm.validate((valid) => {
        if (!valid) {
          self.$Message.warning('信息输入错误!')
          self.loadingConfirm = false
          return
        }
        self.tempLessonParam.lsnBeginTime = self.getLsnBeginTime()
        self.$http.post('/user/lesson/addCourse', self.tempLessonParam).then(function (res) {
          self.loadingConfirm = false
          if (res) {
            self.visible = false
            self.$Message.success('约课成功!')
            self.successCallback()
            return
          }
        })
      })
    },
    searchTch () {
      let self = this
      self.syncPickerTime()
      let isNotError = true
      self.$refs.tempLessonForm.validateField('lsnBeginDayTime', (valid) => {
        if (valid !== '') isNotError = false
      })
      if (!isNotError) return
      self.loadingSearch = true
      self.tchList = []
      let path = '/tch/time/queryFreeNotChineseTch?lsnBeginTime=' + self.getLsnBeginTime() +
        '&timeLength=' + self.tempLessonParam.timeLength + '&tchType=1&tempSchedule=1&uid=' + self.tempLessonParam.uid
      if (self.ptype === '1') {
        path = path + '&isAudition=y'
      }
      if (self.tempLessonParam.canBound) {
        path = path + '&canBound=' + self.tempLessonParam.canBound
      }
      if (self.tempLessonParam.category) {
        path = path + '&category=' + self.tempLessonParam.category
      }
      if (self.tId) {
        path = path + '&tchId=' + self.tId
      }
      if (self.tempLessonParam.suitableLevel) {
        path = path + '&suitableLevel=' + self.tempLessonParam.suitableLevel
      }
      if (self.tempLessonParam.accent) {
        path = path + '&accent=' + self.tempLessonParam.accent
      }
      if (self.tempLessonParam.sex) {
        path = path + '&sex=' + self.tempLessonParam.sex
      }
      if (self.tempLessonParam.channel) {
        path = path + '&channel=' + self.tempLessonParam.channel
      }

      self.$http.post(path).then(function (res) {
        if (res && res.data) {
          self.tchList = res.data
        }
        self.loadingSearch = false
      })
    },
    onChangeTime (val) {
      this.tempLessonParam.time = val && parseInt(this.$dateUtil.getSecondByHm(val))
      this.clearTchList()
      this.selectLevel()
    },
    lsnBeginTimeDateChange (value) {
      this.tempLessonParam.lsnBeginDayTime = value && parseInt(this.$moment(value, 'YYYY-M-D').format('X'))
      this.clearTchList()
      this.selectLevel()
    },
    selectLevel () {
      let self = this
      let lsnEndTime= self.getLsnBeginTime()+self.tempLessonParam.timeLength*60
      let uid= self.tempLessonParam.uid
      self.$http.get('/user/selectLevelIdByUidAndTime?uid='+uid+'&lsnEndTime='+lsnEndTime).then(function (res) {
        if (res && res.data > 0) {
          self.tempLessonParam.levelId = res.data
        }
      })
    },

    loadBookMaterialLevel () {
      let self = this
      if (self.bookMaterialLevelList) {
        return
      }
      self.$http.get('/bookMaterialLevel/listByCondition?status=1&ptypeList=1&ptypeList=2').then(function (res) {
        if (!res || !res.data) {
          return
        }
        self.bookMaterialLevelList = res.data
        self.tempLessonParam.levelId = self.user.levelId
      })
    },
    changeLevel (val) {
      if (!val) {
        return
      }
      let self = this
      for (let i = 0; i < self.bookMaterialLevelList.length; i++) {
        let item = self.bookMaterialLevelList[i]
        if (item.id === val) {
          self.ptype = item.ptype
          self.tempLessonParam.courseType = item.lessonType
          break
        }
      }
      self.bookMaterialLessonsList = null
      self.$http.get('/bookMaterialLessons/listByCondition?status=1&levelId=' + val).then(function (res) {
        if (!res || !res.data) {
          return
        }
        self.bookMaterialLessonsList = res.data
      })
      if (self.tempLessonParam.courseType === 1) {
        self.timeLength = 25
      }
    },
    getLsnBeginTime () {
      return parseInt(this.tempLessonParam.lsnBeginDayTime) + parseInt(this.tempLessonParam.time)
    },
    clearTchList () {
      this.tchList = []
      this.tempLessonParam.tchId = ''
    },
    showTchMessage (id) {
      this.tchId = parseInt(id)
      this.showTchInfoModal = true
    },
    updateTchInfoSuccess () {
      this.showTchInfoModal = false
    },
    onTchChange (id, name) {
      this.tchName = name
      if (id) {
        this.searchTch()
      }
    }
  },
  watch: {
    value (val) {
      this.visible = val
    },
    visible (val) {
      if (val === true) {
        this.tchList = []
        this.loadingConfirm = false
        this.loadingSearch = false
        this.bookMaterialLevelList = null
        this.bookMaterialLessonsList = null
        this.loadBookMaterialLevel()
        this.tempLessonParam.uid = this.user.id
        this.tempLessonParam.nickname = this.user.nickname
        this.tempLessonParam.mobile = this.user.mobile
        this.tempLessonParam.levelId = this.user.levelId
        let now = new Date()
        now = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        this.tempLessonParam.lsnBeginTimeDate = now
        this.tempLessonParam.lsnBeginDayTime = now.getTime() / 1000
        this.timeStr = '18:00'
        this.tempLessonParam.time = 18 * 3600
        this.timePickerKey += 1
        this.tempLessonParam.levelId = ''
        this.tempLessonParam.lessonId = ''
      } else {
        this.tId = ''
        this.tchName = ''
      }
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// UserTempLessonModal.vue?37fa17ab